import React, { createContext, useContext, useEffect, useState } from 'react';
import apiClient from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('gmwc_token');
    if (!token) {
      setLoading(false);
      return;
    }
    apiClient
      .get('/auth/me')
      .then((res) => setUser(res.data.user))
      .catch(() => {
        localStorage.removeItem('gmwc_token');
      })
      .finally(() => setLoading(false));
  }, []);

  function loginSuccess(token, userData) {
    localStorage.setItem('gmwc_token', token);
    setUser(userData);
  }

  function logout() {
    localStorage.removeItem('gmwc_token');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, setUser, loading, loginSuccess, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
